import { Typography, GridLegacy as Grid } from '@mui/material';
import LoadingPage from 'components/ui/LoadingPage';
import React from 'react';

import { useRouter } from '../../hooks/useRouter';
import { BoatWithRelations, useGetBoatsQuery } from '../../redux/ellipsisApi';

import ListingCard from './ListingCard';

interface OwnProps {
  limit?: string;
  location?: string;
}
const BoatList: React.FC<OwnProps> = (props) => {
  const { limit } = props;
  const boatLimit = limit ?? '100';
  const { data: allBoats, isLoading: allBoatsIsLoading } = useGetBoatsQuery({
    limit: boatLimit,
  });
  const router = useRouter();

  return (
    <>
      <Grid item xs={12} mt={4} mb={4}>
        <Typography variant="h1" align="left">
          All boats
        </Typography>
      </Grid>
      <Grid container spacing={4}>
        {allBoats &&
          allBoats?.map((boat: BoatWithRelations, key: number) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <ListingCard
                bookable={boat}
                bookableType={'Boat'}
                router={router}
              />
            </Grid>
          ))}
      </Grid>
      {allBoatsIsLoading && <LoadingPage background="white" />}
    </>
  );
};

export default BoatList;
